let language = {
    ORDERS_TITLE_NO: "订单号",
    ORDERS_TITLE_DATE: "订单日期",
    ORDERS_TITLE_STATUS: "状态",
    ORDERS_TITLE_PRODUCTS: "产品",
    ORDERS_TITLE_RESET: "重置",
    ORDERS_TITLE_SEARCH: "搜索"
}

export { language }
